// extracted by mini-css-extract-plugin
export default {"wrapper":"Pay_wrapper__oPl15","header":"Pay_header__BLGYE","goBack":"Pay_goBack__lP9NI","container":"Pay_container__ku9yR"};